<template>
    <el-form :model="newsData" ref="newsForm" :rules="validateRules" label-width="100px">
        <el-form-item label="标题" prop="newsContentTitle">
            <el-input v-model="newsData.newsContentTitle" auto-complete="off" placeholder="新闻标题（必填）"></el-input>
        </el-form-item>
        <el-form-item label="来源" prop="newsContentSource">
            <el-input v-model="newsData.newsContentSource" auto-complete="off" placeholder="新闻来源（必填）"></el-input>
        </el-form-item>
        <template v-for="i in lunboSlideNum">
            <el-form-item class="yd-lunbo-long-words" label="图片（尺寸640*320）" prop="newsContentImage" style="margin-bottom:10px;">
                <el-input @blur="lunboImgsBlur(i-1)" v-model="lunboImages[i-1]" auto-complete="off" placeholder="图片链接（必填）"></el-input>
            </el-form-item>
            <el-form-item label="落地页" prop="lunboURLs" style="margin-bottom:18px;">
                <el-input v-model="lunboURLs[i-1]" auto-complete="off" placeholder="网站链接（选填）"></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="lunboInfos">
                <el-input v-model="lunboInfos[i-1]" auto-complete="off" placeholder="描述内容（选填）"></el-input>
            </el-form-item>
        </template>
        <el-form-item v-if="isEdit" label="置顶权重"  prop="newsContentIsTop">
            <el-input v-model="newsData.newsContentIsTop" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button-group>
                <el-button type="primary" @click="addSlide">添加slide</el-button>
                <el-button type="danger" v-if="lunboSlideNum>1" @click="delSlide">删除slide</el-button>
                <el-button type="success" @click="newsFormSubmit">提交</el-button>
                <el-button v-if="addForm" @click="newsFormReset">重置</el-button>
                <el-button v-else @click="newsFormCancle">取消</el-button>
            </el-button-group>
        </el-form-item>
    </el-form>
</template>
<script>
export default {
    props: ["newsData", "addForm", "lunboImages", "lunboSlideNum", "lunboURLs", "lunboInfos","isEdit"],
    data(){
        return {
            validateRules: {
                newsContentTitle: [
                    { required: true, message: '请填写新闻标题', trigger: 'blur' }
                ],
                newsContentSource: [
                    { required: true, message: '请填写新闻来源', trigger: 'blur' }
                ],
                newsContentImage: [
                    { required: true, message: '请填写图片地址', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        newsFormCancle() {
            this.$emit('newsFormCancle');
        },
        newsFormSubmit() {
            let flag = true;
            this.$refs.newsForm.validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$emit('newsFormSubmit', this.newsData, this.addForm);
        },
        newsFormReset() {
            this.$refs.newsForm.resetFields();
            this.$emit('newsFormReset');
        },
        addSlide() {
            this.$emit('addSlide');
        },
        delSlide() {
            this.$emit('delSlide');
        },
        lunboImgsBlur(i){
            this.newsData.newsContentImage = '';
            var passed = this.lunboImages.every((element, index, array)=>{
                return !array[index] == false;
            });
            if(passed){
                this.newsData.newsContentImage = this.lunboImages.join(";");
            }
        }
    }
}
</script>
<style lang="less">
.yd-lunbo-long-words {
    .el-form-item__error {
        top: 84%;
    }
    .el-form-item__label {
        padding-top: 4px;
    }
}
</style>




// WEBPACK FOOTER //
// SlidesNews.vue?9c7722ea